import transparentBackground from "@/assets/images/transparent.jpg";
import type { SlideFields } from "@/types/Slide";
import type { WordSlideData } from "@ai-teach/types";
import { AiFillPicture } from "react-icons/ai";

interface WordPronunciationThumbnailProps {
  slide: SlideFields;
}

export function WordPronunciationThumbnail({ slide }: WordPronunciationThumbnailProps) {
  const wordSlideData = slide.slideData as WordSlideData;

  return (
    <div className="bg-accent-50 shadow-sm p-2 h-full flex flex-col justify-center overflow-hidden">
      {/* Image Section */}
      <div className="relative aspect-square border-2 border-accent-400 w-full flex items-center justify-center bg-gray-200 dark:bg-gray-800 rounded-lg overflow-hidden shrink-0">
        {wordSlideData.image?.src ? (
          <>
            <img
              src={transparentBackground}
              alt="transparent-bg"
              className="w-full h-full object-cover absolute z-0"
            />
            <img
              src={wordSlideData.image.src}
              alt={wordSlideData.word || "image"}
              className="w-full h-full object-cover z-30"
            />
          </>
        ) : (
          <AiFillPicture className="text-gray-400 dark:text-gray-600 text-4xl" />
        )}
      </div>

      {/* Word */}
      <div className="relative overflow-hidden flex items-center justify-center py-4 mt-3 bg-white rounded-lg border-accent-400 shadow-md">
        <h2 className="font-semibold text-gray-900 tracking-tight @[150px]:text-base @[200px]:text-xl truncate">
          {wordSlideData.word || "No Word"}
        </h2>
      </div>

      {/* Syllables */}
      <div className="relative overflow-hidden flex items-center justify-center py-4 mt-3 bg-white rounded-lg border-accent-400 shadow-md">
        <h2 className="font-semibold text-gray-900 tracking-tight @[150px]:text-base @[200px]:text-xl truncate">
          {wordSlideData.syllable || "No Syllable"}
        </h2>
      </div>
    </div>
  );
}
